<template>
        <el-select class="ele-select" :clearable="clearable" :multiple="multiple" :value-key="type=='object'?'packageTypeCode':''" @visible-change="visiblechange" @change="change" :size="size" :value="value" :placeholder="placeholder">
            <el-option
                    v-for="item in list"
                    :key="item.packageTypeCode"
                    :label="item.packageName"
                    :value="type=='object'?item:item.packageTypeCode">
            </el-option>
        </el-select>
</template>

<script>
    export default {
        name: "package-types",
        props:{
            size:String,
            placeholder:String,
            clearable:Boolean,
            multiple:Boolean,
            value:String|Object|Array,
            type:String//是对象还是字符串
        },
        model:{
            prop:'value',
            event:'input'
        },
        data(){
            return{
                list:[],
                // value:''
            }
        },
        mounted(){
            this.getData();
        },
        methods:{
            getData(){
                this.$axios.get("/foodPackage/foodPackageListByStoreId/"+this.$root.getStorage('storeId')).then(res => {
                    // console.log('套餐类型',res)
                    this.list = res.data.list;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            visiblechange(isshow){
                if(isshow){
                    this.getData();
                }
            },
            change(value){
                console.log(value)
                this.$emit('input',value)
            }
        }
    }
</script>

<style scoped>

</style>